import { CLAUDE_LOGS } from "@/rbac/links.js";

import { VIEW_CLAUDE_LOG } from "@/rbac/permissions.js";

function props(route) {
  let orderByDefault = route.query.order_by_created_at || "desc";

  if (
    route.query.order_by_id ||
    route.query.order_by_type_name ||
    route.query.order_by_role_name ||
    route.query.order_by_staff_full_name ||
    route.query.order_by_client_id ||
    route.query.order_by_client_full_name ||
    route.query.order_by_query ||
    route.query.order_by_model ||
    route.query.order_by_input_tokens ||
    route.query.order_by_output_tokens ||
    route.query.order_by_updated_at
  ) {
    orderByDefault = null;
  }

  return {
    page: parseInt(route.query.page) || 1,
    limit: parseInt(route.query.limit) || 10,

    id: parseInt(route.query.id) || null,
    order_by_id: route.query.order_by_id || null,

    type_id: parseInt(route.query.type_id) || null,
    order_by_type_name: route.query.order_by_type_name || null,

    role_id: parseInt(route.query.role_id) || null,
    order_by_role_name: route.query.order_by_role_name || null,

    user_id: parseInt(route.query.user_id) || null,
    order_by_staff_full_name: route.query.order_by_staff_full_name || null,

    client_id: route.query.client_id || null,
    order_by_client_id: route.query.order_by_client_id || null,

    client_full_name: route.query.client_full_name || null,
    order_by_client_full_name: route.query.order_by_client_full_name || null,

    query: route.query.query || null,
    order_by_query: route.query.order_by_query || null,

    model: route.query.model || null,
    order_by_model: route.query.order_by_model || null,

    input_tokens: parseInt(route.query.input_tokens) || null,
    order_by_input_tokens: route.query.order_by_input_tokens || null,

    output_tokens: parseInt(route.query.output_tokens) || null,
    order_by_output_tokens: route.query.order_by_output_tokens || null,

    order_by_created_at: orderByDefault,
    order_by_updated_at: route.query.order_by_updated_at || null,
  };
}

const claudeLogRoutes = [
  {
    path: "/nacd-ai-logs",
    component: () =>
      import(
        /* webpackChunkName: "system-layout" */ "@/views/system/Layout.vue"
      ),
    children: [
      {
        path: "",
        name: "ClaudeLogIndex",
        meta: {
          title: "NACD AI Logs",
          permission: CLAUDE_LOGS,
        },
        props: (route) => props(route),
        component: () =>
          import(
            /* webpackChunkName: "claude-log-index" */ "@/views/system/claude-log/Index.vue"
          ),
      },

      {
        path: ":id/view",
        name: "ClaudeLogView",
        meta: {
          title: "View NACD AI Log",
          permission: VIEW_CLAUDE_LOG,
        },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "claude-log-view" */ "@/views/system/claude-log/View.vue"
          ),
      },
    ],
  },
];

export default claudeLogRoutes;
